import PropTypes from 'prop-types';

export const GenericStepProps = {
  icon: PropTypes.node,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  imageSrc: PropTypes.string,
  children: PropTypes.node,
  buttonsProps: PropTypes.shape({
    leftButton: PropTypes.object,
    rightButton: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.arrayOf(PropTypes.object),
    ]),
  }),
};
